import { render, staticRenderFns } from "./LockEditConfirm.vue?vue&type=template&id=edbb6d38&"
import script from "./LockEditConfirm.vue?vue&type=script&lang=js&"
export * from "./LockEditConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LockEditConfirm.vue?vue&type=style&index=0&id=edbb6d38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports